var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowInBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.872129 0.340879C1.20163 0.0113738 1.73587 0.0113738 2.06537 0.340879L7.12787 5.40338C7.45738 5.73288 7.45738 6.26712 7.12787 6.59662L2.06537 11.6591C1.73587 11.9886 1.20163 11.9886 0.872129 11.6591C0.542624 11.3296 0.542624 10.7954 0.872129 10.4659L5.33801 6L0.872129 1.53412C0.542624 1.20462 0.542624 0.670384 0.872129 0.340879Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowInBtn);
export default __webpack_public_path__ + "static/media/arrowInBtn.c3794e4cdf2ed12dd63966a2e9f20846.svg";
export { ForwardRef as ReactComponent };